export default __webpack_public_path__ + "static/media/icon-group-3.4.22d5c3c2.png";